import { GradientPrimary } from './palette';

export const TextGradientPrimaryBackground = `background: ${GradientPrimary}; background-clip: text; -webkit-background-clip: text; -webkit-text-fill-color: transparent;`;
